<template>
  <div
    class="c-outreach-contact-avatar"
    :class="contactClass"
  >
    <div
      v-if="contact.highResAvatarUrl && !contactAvatarError"
      class="outreach-contact-avatar-url"
      :class="{ 'outreach-contact-avatar-url-outlet': type === 'outlets' }"
    >
      <img
        class="outreach-contact-avatar-url-img"
        :src="contact.highResAvatarUrl"
        @error="contactAvatarError = true"
      />
    </div>
    <div
      v-else-if="['outlets', 'outlet_desks'].includes(type)"
      class="outreach-contact-avatar-icon"
    >
      <BaseIcon icon="outlet" />
    </div>
    <InitialBubbles
      v-else
      class="outreach-contact-avatar-bubble"
      :initials-limit="3"
      :names="[contactTitle]"
    />
  </div>
</template>

<script setup>
import { ref } from "vue";

import { BaseIcon } from "shared/components/base";
import InitialBubbles from "shared/components/core/various/InitialBubbles.vue";
import useContact from "shared/composables/useContact";

const props = defineProps({
  contact: {
    type: Object,
    required: true,
  },
});

const { type, contactTitle, contactClass } = useContact(props);

const contactAvatarError = ref(false);
</script>

<style lang="scss" scoped>
@import "shared/css/outreach";

.outreach-contact-avatar {
  &-url {
    border-radius: 50%;
    width: var(--c-outreach-contact-avatar-width);
    height: var(--c-outreach-contact-avatar-height);

    &-outlet {
      > img {
        filter: none;
      }
    }

    &-img {
      width: var(--c-outreach-contact-avatar-width);
      height: var(--c-outreach-contact-avatar-height);
      object-fit: cover;
      border-radius: 50%;
    }
  }

  &-icon {
    width: var(--c-outreach-contact-avatar-width);
    height: var(--c-outreach-contact-avatar-height);
    background-color: var(--c-outreach-contact-color);
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: calc(var(--c-outreach-contact-avatar-width) / 2);

    .s-icon {
      font-size: 1em;
    }
  }

  &-bubble {
    width: var(--c-outreach-contact-avatar-width);
    height: var(--c-outreach-contact-avatar-height);

    > :first-child {
      width: 100%;
    }

    :deep(.initial-bubble) {
      width: var(--c-outreach-contact-avatar-width);
      height: var(--c-outreach-contact-avatar-height);
      font-size: calc(var(--c-outreach-contact-avatar-width) / 2);
      background-color: var(--s-color-denim-6) !important;
    }
  }
}
</style>
